import client from './client';

const eqpUrl = '/api/v1/eqp';

// ============================= (A) 가공 프로그램 파일 =============================
// 장비 상세 "가공 프로그램" 탭 - 파일 목록/버전/다운로드/비교(diff).

export const getProgramFiles = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/program-files`);

export const getProgramVersions = (eqpUuid, fileName) =>
  client.get(`${eqpUrl}/${eqpUuid}/program-files/${encodeURIComponent(fileName)}/versions`);

export const downloadProgramVersion = (eqpUuid, fileName, verId) =>
  client.get(
    `${eqpUrl}/${eqpUuid}/program-files/${encodeURIComponent(fileName)}/versions/${verId}/download`,
    { responseType: 'blob' },
  );

// from/to: 비교할 두 버전의 verId(기본: from이 더 옛날 버전)
export const getProgramDiff = (eqpUuid, fileName, fromVerId, toVerId) =>
  client.get(`${eqpUrl}/${eqpUuid}/program-files/${encodeURIComponent(fileName)}/diff`, {
    params: { from: fromVerId, to: toVerId },
  });

export const extractList = (res) => res?.data?.list ?? [];
export const extractInfo = (res) => res?.data?.info ?? null;
